import { useEffect, useRef } from 'react'
import { getRoundTripOfferKey } from './offerMapUtils'

const useSelectedOfferPage = ({
  isDrawerOpen,
  selectedOfferKey,
  matches,
  pageSize,
  setPage
}) => {
  const followedSelectionRef = useRef(null)

  useEffect(() => {
    if (!isDrawerOpen || !selectedOfferKey) {
      followedSelectionRef.current = null
      return
    }
    if (
      followedSelectionRef.current?.key !== selectedOfferKey ||
      followedSelectionRef.current.pageSize !== pageSize
    ) {
      followedSelectionRef.current = {
        key: selectedOfferKey,
        pageSize,
        followed: false
      }
    }
    if (followedSelectionRef.current.followed) return

    const selectedIndex = matches.findIndex(
      match => getRoundTripOfferKey(match) === selectedOfferKey
    )
    if (selectedIndex < 0) return

    followedSelectionRef.current.followed = true
    setPage(Math.floor(selectedIndex / pageSize) + 1)
  }, [isDrawerOpen, matches, pageSize, selectedOfferKey, setPage])
}

export default useSelectedOfferPage
